import { SimpleForm, TextInput, required } from 'react-admin';

const IncidentResponseTypeForm = () => (
  <SimpleForm>
    <TextInput source="name" validate={[required()]} />
  </SimpleForm>
);

export default IncidentResponseTypeForm;
